module.exports = __webpack_public_path__ + "static/media/Sports.0f2011a3.png";